import Blogs from "./blogs";
import User from "./user";
import Clients from "./clients";
import Project from "./project";
import clip from "./clip";
import mentions from "./mentions";
import heatmap from "./heatmap";
import products from "./products";
import topPosts from "./top-posts";
import topAuthors from "./top-authors";
import influencerDiscovery from "./influencer-discovery";
import dailyInsights from "./daily-insights";
import subfolders from "./subfolders";
import ReactionLists from "./reaction-lists";
import Sortbins from "./sortbins";
import clientContact from "./client-contact";
import wordCloud from "./word-cloud";
import favourability from "./favourability";
import worldMap from "./world-map";
import accessToken from "./access-token";
import sentiment from "./sentiment";
import mentor from "./mentor";
import report from "./reports";
import competitor from "./competitor";
import deepDiveBreakdown from "./deep-dive-breakdown";
import Contact from "./contact";
import profile from "./profile";
import notifications from "./notifications";
import account from "./account";
import CrmCategory from "./crm-category";
import agreementProjectSetup from "./agreement-project-setup";
import influencerComparison from "./influencer-comparison";
import alert from "./alert";
import core from "./core";
import focalPoints from "./focal-points";
import board from "./board";

const api = {
    blogs: Blogs,
    user: User,
    clients: Clients,
    project: Project,
    clip: clip,
    core: core,
    mentions: mentions,
    heatmap: heatmap,
    products: products,
    topPosts: topPosts,
    topAuthors: topAuthors,
    influencerDiscovery: influencerDiscovery,
    dailyInsights: dailyInsights,
    subfolders: subfolders,
    reactionLists: ReactionLists,
    sortbins: Sortbins,
    clientContact: clientContact,
    wordCloud: wordCloud,
    favourability: favourability,
    worldMap: worldMap,
    accessToken: accessToken,
    mentor: mentor,
    report: report,
    competitor: competitor,
    sentiment: sentiment,
    deepDiveBreakdown: deepDiveBreakdown,
    contact: Contact,
    profile: profile,
    notifications: notifications,
    account: account,
    CrmCategory: CrmCategory,
    agreementProjectSetup: agreementProjectSetup,
    influencerComaprison: influencerComparison,
    alert: alert,
    focalPoints: focalPoints,
    board: board,
};

/*Production Variables */
export const API_URI = "https://api.amasocial.co.za";
export const CRM_API_URI = "https://crm-api.amasocial.co.za";
export const MENTOR_API_URI = "https://mentor-api.amasocial.co.za";
export const KEYWORDS_API_URI = "https://keywords.amasocial.co.za";

/*Test Variables */
// export const API_URI = "https://localhost:44314";
// export const CRM_API_URI = "https://localhost:44333";
// export const KEYWORDS_API_URI = "https://localhost:44382";
// export const PROJECT_SETUP_URI = "https://localhost:44339";
// export const MENTOR_API_URI = "https://localhost:44377";

function handleResponse(res: Response) {
    const contentType = res.headers.get("content-type");
    if (res.status === 401) {
        window.location.replace(process.env.PUBLIC_URL + "/login");
    } else if (res.status === 201 || res.status === 202) {
        if (contentType) {
            if (contentType.indexOf("application/json") !== -1 || contentType.indexOf("text/plain") !== -1) {
                return res.json();
            }
        } else {
            return res;
        }
    } else if (!res.ok) {
        throw Error(res.statusText);
    } else {
        if (contentType) {
            if (contentType.indexOf("application/json") !== -1 || contentType.indexOf("text/plain") !== -1) {
                return res.json();
            }
        } else {
            return res;
        }
    }
}

async function handleDownload(res: Response, fileFormat: string) {
    const data = await res.json();

    var binaryString = window.atob(data.Data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    var blob = new Blob([bytes], { type: fileFormat });
    var link = document.createElement("a");
    link.setAttribute("target", "_blank");
    link.href = window.URL.createObjectURL(blob);
    link.download = data.FileName;
    link.click();
}

export async function apiGet(url: string) {
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.AccessToken}`,
        },
    }).then((res) => handleResponse(res));
}

export async function apiDownload(url: string, fileFormat: string, body?: object) {
    return await fetch(url, {
        method: "GET",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.AccessToken}`,
        },
    }).then((res) => handleDownload(res, fileFormat));
}

export async function apiPost(url: string, body?: object) {
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiPut(url: string, body?: object) {
    return fetch(url, {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
            "content-type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiPostAnon(url: string, body?: object) {
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
        },
    }).then((res) => handleResponse(res));
}

export async function apiDelete(url: string, body?: object) {
    return fetch(url, {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${localStorage.AccessToken}`,
        },
    }).then((res) => handleResponse(res));
}

export default api;
